export interface VehicleAbsDto {
  frontLeftWheelSpeed?: number;
  frontRightWheelSpeed?: number;
  rearLeftWheelSpeed?: number;
  rearRightWheelSpeed?: number;
  secondRearLeftWheelSpeed?: number;
  secondRearRightWheelSpeed?: number;
  errorsNumber?: number;
}
